import { useState, useEffect, createContext, useContext } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import CommandPalette from "@/components/CommandPalette";

export const ClusterContext = createContext({ clusterId: "prod-us-east", setClusterId: () => {} });
export const useCluster = () => useContext(ClusterContext);

export default function Layout() {
  const [clusterId, setClusterId] = useState("prod-us-east");
  const [cmdOpen, setCmdOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "k") {
        e.preventDefault();
        setCmdOpen(true);
      }
    };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, []);

  return (
    <ClusterContext.Provider value={{ clusterId, setClusterId }}>
      <div className="flex h-screen bg-slate-950 overflow-hidden">
        <Sidebar collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} />
        <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
          <TopBar clusterId={clusterId} setClusterId={setClusterId} onSearchOpen={() => setCmdOpen(true)} />
          <main className="flex-1 overflow-y-auto p-4 sm:p-6">
            <Outlet />
          </main>
        </div>
        <CommandPalette open={cmdOpen} onClose={() => setCmdOpen(false)} />
      </div>
    </ClusterContext.Provider>
  );
}
